import { ValidId } from '@purposity/utils'
import * as z from 'zod'

const teamJoin = z.object({
  id: ValidId,
})

const teamLeave = z.object({
  id: ValidId,
})

const teamInvite = z.object({
  id: ValidId,
})

const orgFollow = z.object({
  id: ValidId,
  orgName: z.string(),
  team: z.string().optional(),
})

const orgUnfollow = z.object({
  id: ValidId,
})

/** derived from CheckoutSession
 * @see packages/backend-sdk/src/features/transactions/types.ts
 * */
const transactionSchema = z.object({
  // line_items: z
  //   .custom<
  //     | Products.Tip.LineItem
  //     | Products.Need.LineItem
  //     | Products.Designated.LineItem
  //   >()
  //   .array(),
  // summary: z.object({
  //   count: z.number().int(),
  //   sum: z.number(),
  // }),
  user_id: z.string(),
  checkout_intent_id: z.string().optional(),
  checkout_session_id: z.string().optional(),
})

const checkoutCreate = transactionSchema.partial()

const checkoutComplete = transactionSchema.partial()

const checkoutCancel = z.object({
  user_id: z.string(),
  checkout_intent_id: z.string(),
})

const checkoutExpire = z.object({
  user_id: z.string(),
  checkout_session_id: z.string(),
})

const goalSet = z.object({
  //
})

const userSignup = z.object({
  user_id: z.string(),
})

const userLogin = z.object({
  user_id: z.string(),
})

const userLogout = z.object({
  user_id: z.string(),
})

const needShare = z.object({
  needId: ValidId,
  needTitle: z.string(),
  user_id: z.string(),
  isUrgent: z.boolean().optional(),
  liveNeed: z.boolean().optional(),
})

const teamShare = z.object({
  teamId: ValidId,
  teamName: z.string(),
  user_id: z.string(),
})

const orgShare = z.object({
  orgId: ValidId,
  orgName: z.string(),
  user_id: z.string(),
})

const onboardingStart = z.object({
  //
})

const onboardingComplete = z.object({
  test: z.literal('me').optional(),
})

const storyClick = z.object({
  storyTitle: z.string(),
})

const followingTabClick = z.object({
  // Empty object since we don't need any additional properties
})

const needClick = z.object({
  needId: ValidId,
  needTitle: z.string(),
  isUrgent: z.boolean(),
  liveNeed: z.boolean(),
})

const profileButtonClick = z.object({
  // Empty object since we don't need any additional properties
})

const pageView = z.object({
  url: z.string(),
})

export const EventMap = z.object({
  'Page View': pageView,
  'Team Join': teamJoin,
  'Team Leave': teamLeave,
  'Team Invite': teamInvite,
  'Organization Follow': orgFollow,
  'Organization Unfollow': orgUnfollow,
  'Goal Set': goalSet,
  'User Signup': userSignup,
  'User Login': userLogin,
  'User Logout': userLogout,
  'Checkout Create': checkoutCreate,
  'Checkout Complete': checkoutComplete,
  'Checkout Cancel': checkoutCancel,
  'Checkout Expire': checkoutExpire,
  'Need Share': needShare,
  'Team Share': teamShare,
  'Organization Share': orgShare,
  'Onboarding Start': onboardingStart,
  'Onboarding Complete': onboardingComplete,
  'Story View': storyClick,
  'Following Tab Click': followingTabClick,
  'Need Click': needClick,
  'Profile Click': profileButtonClick,
})
export type EventMap = z.infer<typeof EventMap>

export type Options = {
  eventId?: string
}
